import { FC } from "react";
import { TableCell, TableRow } from "../ui/table";
import { formatDate } from "../../lib/helpers/date_helpers";
import { Button } from "../ui/button";
import { Download } from "lucide-react";
import saveAs from "file-saver";
import { toast } from "sonner";
import { Abonnement } from "../../lib/interfaces/abonnement.interface";
import { useAttestationSnaFile } from "@/lib/hooks/useAbonnements";

interface Props {
  abonnement: Abonnement;
}

const AttestationSnaRowItem: FC<Props> = ({ abonnement }) => {
  const { mutateAsync: getAttestationFile, isPending: loadingAttestation } = useAttestationSnaFile();

  const telechargerAttestation = async () => {
    try {
      const data = await getAttestationFile(abonnement.id);
      const blob = new Blob([data], {
        type: "application/pdf",
      });
      saveAs(blob, "attestation-affiliation-sna.pdf");
    } catch (error) {
      toast.error("Une erreur s'est produite.");
      console.error(error);
    }
  };

  return (
    <TableRow className="block px-4 py-3 hover:bg-slate-50/70 sm:table-row sm:px-0 sm:py-0">
      <TableCell className="block px-0 pb-2 pt-0 font-semibold text-slate-900 sm:table-cell sm:px-6 sm:py-4">
        Adhésion à une structure affiliée au SNA
      </TableCell>
      <TableCell className="flex items-center justify-between gap-4 px-0 py-1.5 text-sm text-slate-600 sm:table-cell sm:p-4">
        <span className="font-medium text-slate-500 sm:hidden">Validité</span>
        <span>
          Du {formatDate(abonnement.dateDebut)} au {formatDate(abonnement.dateFin)}
        </span>
      </TableCell>
      <TableCell className="block px-0 pb-0 pt-3 text-right sm:table-cell sm:px-6 sm:py-4">
        <Button
          className="w-full bg-[#173f35] hover:bg-[#23594a] sm:w-auto"
          onClick={() => telechargerAttestation()}
          loading={loadingAttestation}
          icon={<Download className="h-4 w-4" />}
          size="sm"
        >
          Télécharger
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default AttestationSnaRowItem;
